import {
	type Control,
	Controller,
	type FieldPath,
	type FieldValues,
} from "react-hook-form";
import {
	SliderRow,
	type SliderRowProps,
} from "web_myplann/Shared/Components/SliderRow";

type Props<FormType extends FieldValues, TName> = Omit<
	SliderRowProps,
	"value" | "onChange" | "valueLabel" | "min" | "max" | "minLabel" | "maxLabel"
> & {
	control: Control<FormType>;
	name: TName;
	min: number;
	max: number;
	formatValue: (value: number) => string;
	minLabel?: string;
	maxLabel?: string;
	onValueChange?: (value: number) => void;
};

export const SliderFormRow = <
	FormType extends FieldValues,
	TName extends FieldPath<FormType>,
>({
	control,
	name,
	min,
	max,
	formatValue,
	minLabel = formatValue(min),
	maxLabel = formatValue(max),
	onValueChange,
	...rest
}: Props<FormType, TName>) => (
	<Controller
		control={control}
		name={name}
		render={({ field: { value, onChange } }) => (
			<SliderRow
				{...rest}
				min={min}
				max={max}
				minLabel={minLabel}
				maxLabel={maxLabel}
				value={value}
				valueLabel={formatValue(value)}
				onChange={(next) => {
					onChange(next);
					onValueChange?.(next);
				}}
			/>
		)}
	/>
);
